module.exports = __webpack_public_path__ + "static/media/quran.d17c25a7.svg";